// Primary public surface — Service classes mirror iframe lib, drop-in replacements.
export { BlackjackSDKService } from './BlackjackSDKService.js';
export { RouletteSDKService } from './RouletteSDKService.js';
export { BaccaratSDKService } from './BaccaratSDKService.js';

// Advanced: raw transport for studios with their own game semantics.
export { DealerSDK } from './DealerSDK.js';

// Pinned SDK types
export type {
  SDKServiceConfig,
  SDKEventMap,
  SDKEventName,
  SDKStateSnapshot,
  SDKLogger,
  AgentState,
  DealerVideoTrack,
  ToolEffect,
  TranscriptionSegment,
  TranscriptionSpeaker,
  MicStatus,
} from './types.js';
export { AlreadyConnectedError, SDK_EVENT_NAMES } from './types.js';
export { SessionConnectError, isTerminalSessionError } from './connection.js';

// Renderer-agnostic widget seam (WIDGET track): one UI, two data adapters.
// `createSdkStateSource` is the SDK adapter; renderers consume the StateSource.
export { createSdkStateSource } from './state-source.js';
export {
  foldCaption,
  CAPTION_HISTORY_LIMIT,
  type WidgetState,
  type WidgetActions,
  type WidgetAgentState,
  type StateSource,
} from '../core/logic/widget-state.js';

// Core re-exports — event namespaces + service-mode helpers for consumers.
export { BlackjackEvents } from '../core/events/blackjack.js';
export { RouletteEvents } from '../core/events/roulette.js';
export { BaccaratEvents } from '../core/events/baccarat.js';
export { ServiceMode, parseServiceMode, SERVICE_MODE_LABELS } from '../core/types/service-mode.js';

// Decision #11 — PTTStateMachine opt-in re-export for studios that want the
// swipe-cancel state logic without writing their own.
export {
  PTTStateMachine,
  type PTTStateMachineOptions,
  type PTTStateSnapshot,
} from '../core/logic/ptt-state.js';

// Universal AI event types
export { AIEventType, type AIEvent } from '../core/types/ai-types.js';
